/**
 * easing equations
 * t = current time
 * b = start value
 * c = delta value
 * d = duration
 */

export function easeOutQuart(t: number, b: number, c: number, d: number) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
}


export function initSpin(currDegree: number, spinN: number, prizeReceived: number[]) {
    const spins = getRandom(7, 9);
    let degrees = getRandom(0, 360);

    const canHasHeartAttack = spinN === 3;
    let hasHeartAttack = false;

    if (canHasHeartAttack) {
        hasHeartAttack = getRandom(1, 3) === 3;
    }

    let prize: number;

    if (hasHeartAttack) {
        degrees = getRandom(292, 334);
        prize = getPrizeIndex(degrees);

    } else {
        prizeReceived.push(7); // Heart Attack
        prize = getPrizeIndex(degrees);

        while (prizeReceived.includes(prize)) {
            degrees = getRandom(0, 360);
            prize = getPrizeIndex(degrees);
        }
    }

    const totalDegrees = spins * 360 + degrees;
    const delta = totalDegrees - currDegree;

    return [delta, prize];
}

export function getPrizeIndex(degrees: number): number {
    const prizes = [
        [335, 22], // Cancer (Insured)
        [23, 64], // Heartburn (200)
        [65, 111], // Dengue (30000)
        [112, 154], // Lagnat (100)
        [155, 201], // Stroke (Insured)
        [202, 244], // Diabetes (450000)
        [245, 291], // Cough (200)
        [292, 334], // Heart Attack (1M)
    ]

    let prize = 0;
    for (let i = 0; i < prizes.length; i++) {
        const [min, max] = prizes[i];
        if(min > max) {
            if(degrees >= min || degrees <= max) {
                prize = i;
            }
        }
        else if (degrees >= min && degrees <= max) {
            prize = i;
        }
    }

    return prize;
    // return Math.floor((degrees + (360 / sections / 2)) / (360 / sections)) % sections;
}

export function getPrizeAmount(prize: number) {
    const prizes = [
        0, // Cancer (Insured)
        200, // Heartburn (200)
        30000, // Dengue (30000)
        100, // Lagnat (100)
        0, // Stroke (Insured)
        450000, // Diabetes (450000)
        200, // Cough (200)
        1000000, // Heart Attack (1M)
    ]

    return prizes[prize];
}

export function getPrizeName(prize: number) {
    const prizes = [
        'Cancer', // Cancer (Insured)
        'Heartburn', // Heartburn (200)
        'Dengue', // Dengue (30000)
        'Lagnat', // Lagnat (100)
        'Stroke', // Stroke (Insured)
        'Diabetes', // Diabetes (450000)
        'Cough', // Cough (200)
        'Heart Attack', // Heart Attack (1M)
    ]

    return prizes[prize];
}

function getRandom(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return Math.floor(Math.random() * (max - min) + min);
}